/* global System */
// register component(s) with react habitat

export default {
  Videos: () =>
    System.import(
      /* webpackChunkName: "NewReactVC" */
      './Component'
    ),
}
